const Step = ({ step, className = '' }) => (
  <div className={`flex gap-2 ${className}`}>
    <div className='rounded-full shrink-0 outline outline-2 outline-green-800 w-6 h-6 text-green-800 flex justify-center items-center font-semibold text-2xs'>
      {step.number}
    </div>
    <p className='text-black text-left font-medium text-xs'>
      {step.description}
    </p>
  </div>
)

export default Step
